import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Auth0Provider } from "@auth0/auth0-react";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./redux/store";

import "./index.scss";

import Hotjar from '@hotjar/browser';

// Benign browser warning from Ant Design layout/InfiniteScroll in dev.
const resizeObserverErr = /^ResizeObserver loop/;
window.addEventListener("error", (event) => {
  if (resizeObserverErr.test(event.message)) {
    event.stopImmediatePropagation();
  }
});

const siteId = 5166593;
const hotjarVersion = 6;

Hotjar.init(siteId, hotjarVersion);

ReactDOM.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
    redirectUri={window.location.origin + "/callback"}
  >
    <Provider store={store}>
      <App />
    </Provider>
  </Auth0Provider>,
  document.getElementById("root")
);

reportWebVitals();
